import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services';

@Injectable()
export class LoggedinGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserService
    ) {
    }
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.userService.getToken() && this.userService.getData()) {
            this.router.navigate(['/company']);
            return false;
        }
        else if (!this.userService.getToken() && this.userService.getData()) {
            this.router.navigate(['/lock']);
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/guards/loggedin.guard.ts